export const translationKey = 'builder.career_assessment.results.career_insights'
export const analyticEventsLabel = 'career_assessment'
